import { axios } from '@/utils/request'

export function getPresetConfig(params) {
    return axios({
        url: 'commons/preset_config',
        method: 'get',
        params: params
    })
}

export function getUploadPayload(params) {
    return axios({
        url: 'uploads/payload',
        method: 'get',
        params: params
    })
}

export function getBulletinList() {
    return axios({
        url: 'bulletins',
        method: 'get'
    })
}

export function getLatestVersion() {
    return axios({
        url: 'commons/latest_version',
        method: 'get'
    })
}

export function storeFeedback(data) {
    return axios({
        url: 'feedbacks',
        method: 'post',
        data: data
    })
}

// 每日读经
export function getDailySentences(params) {
    return axios.get('daily_sentences', { params: params })
}

// 代祷列表
export function getIntercessions(params) {
    return axios.get('intercessions', { params: params })
}
// 代祷发布
export function storeIntercession(data) {
    return axios.post('/intercessions', data)
}
// 用户代祷列表
export function getUserIntercessions(params) {
    return axios.get('/intercessions/users', { params })
}
export function finishedUserIntercession(intercessionId) {
    return axios.post(`/intercessions/${intercessionId}/finished`)
}

// 类别
export function getCategories(params) {
    return axios.get(`/categories`, { params })
}
